








































import { Component, mixins } from '@niknevis/vue-modules'
import { InjectReactive, Prop } from 'vue-property-decorator'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TesTd from '@/modules/common/tes-table/components/shared/TesTd.vue'
import StepTableCell from '@/modules/content-item/components/writer/table/WriterContentItemStepTableCell.vue'
import DateTooltippedTableCell from '@/modules/shared/components/panel/DateTooltippedTableCell.vue'
import ContentItemContentModal from '@/modules/content-item/components/writer/WriterContentItemContentModal.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'

@Component({
  components: {
    TesTd,
    TesTr,
    ContentItemContentModal,
    BaseButton
  }
})
export default class WriterContentItemTableRow extends mixins<TesTableRow>(TesTableRow) {
  @Prop() row!: any

  @InjectReactive()
  contents!: any

  contentModal = false

  columnComponents = {
    step: StepTableCell,
    deliver_at: DateTooltippedTableCell
  }

  get statuses() {
    return this.contents.statuses
  }

  get contentTypes() {
    return this.contents.content_types
  }
}
